/**
 * !!!HACK!!! simulate react-intl v1 api for legacy modules
 * @todo remove after refactoring
 */

var getIntlMessage = require('../services/settings/settings-store').getIntlMessage;
var React = require('react');
var ReactIntl = require('react-intl');
var IntlMessageFormat = require('intl-messageformat').default;
var FormattedNumber = ReactIntl.FormattedNumber;

var FormattedHTMLMessageStub = React.createClass({
    displayName: 'FormattedHTMLMessageStub',
    render: function() {
        const { message, ...values } = this.props;
        let formatted = '';
        if (this.context.intl) {
            formatted = this.context.intl.formatString(message, values);
        } else {
            var res = new IntlMessageFormat(message, 'ru');
            formatted = res.format(values);
        }
        return <span dangerouslySetInnerHTML={{ __html: formatted }} />;
    }
});

var FormattedMessageStub = React.createClass({
    displayName: 'FormattedMessageStub',
    render: function() {
        const { message, ...values } = this.props;
        let formatted = '';
        if (this.context.intl) {
            formatted = this.context.intl.formatString(message, values);
        } else {
            var res = new IntlMessageFormat(message, 'ru');
            formatted = res.format(values);
        }
        return <span>{formatted}</span>;
    }
});

ReactIntl.ReactIntl = {
    IntlMixin: {
        getIntlMessage: getIntlMessage
    },
    FormattedNumber: FormattedNumber,
    FormattedHTMLMessage: FormattedHTMLMessageStub,
    FormattedMessage: FormattedMessageStub
};
